import UserService from 'App/services/UserService';
import { useMutation } from 'react-query';
import toast from 'Shared/toast';

function useSetDefaultBranch() {
    return useMutation(['user', 'defaultBranch'], {
        mutationFn: (branchId) => {
            return UserService.setDefaultBranch(branchId);
        },
        onSuccess: () => {
            toast.success('Default branch has been set successfully.');
        },
        onError: () => {
            toast.error('Failed to set default branch');
        },
    });
}

export default useSetDefaultBranch;
